import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "source"];
  static values = {
    copiedLabel: { type: String, default: "Kopiert" },
    failedLabel: { type: String, default: "Kopieren fehlgeschlagen" },
  };

  async copy(event) {
    event.preventDefault();

    const copied = await this.write(this.sourceTarget.textContent);
    this.flash(copied ? this.copiedLabelValue : this.failedLabelValue);
  }

  async write(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        // fall through to the textarea fallback below
      }
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);

    try {
      textarea.select();
      return document.execCommand("copy");
    } catch {
      return false;
    } finally {
      textarea.remove();
    }
  }

  flash(label) {
    if (!this.hasButtonTarget) return;

    const button = this.buttonTarget;
    this.originalLabel ??= button.textContent;
    button.textContent = label;

    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout(() => {
      button.textContent = this.originalLabel;
      this.originalLabel = null;
    }, 2000);
  }

  disconnect() {
    clearTimeout(this.resetTimeout);
  }
}
